import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { FormattedMessage } from 'react-intl';

import {
  DeviceVideoWrapper,
  FakeMobileBorderOutter,
  ResponsiveImagesWrapper,
  StyledYoutubeIframe,
} from './style';

const ResponsiveImages = dynamic(import('components/ResponsiveImage/ResponsiveImages'), { ssr: false });

const deviceTypes = {
  light: 'device-frame/device-frame.png',
  dark: 'device-frame-dark/device-frame-dark.png',
};

function DeviceVideo(props) {
  const {
    videoId,
    className,
    deviceType,
    mobileBorderRadius,
    videoTitle,
    hasDeviceOnMobile,
  } = props;

  return (
    <DeviceVideoWrapper className={className}>
      <FakeMobileBorderOutter
        $mobileBorderRadius={mobileBorderRadius}
        $hasDeviceOnMobile={hasDeviceOnMobile}
      >
        <StyledYoutubeIframe
          $hasDeviceOnMobile={hasDeviceOnMobile}
          title={videoTitle}
          videoId={videoId}
          width="255"
          height="454"
          autoplay
          mute
        />
      </FakeMobileBorderOutter>
      <ResponsiveImagesWrapper $hasDeviceOnMobile={hasDeviceOnMobile}>
        <FormattedMessage id="COMMON.DEVICE_VIDEO.IMAGE_ALT">
          {([txt]) => (
            <ResponsiveImages
              fileName={deviceTypes[deviceType]}
              alt={txt}
              loading="lazy"
            />
          )}
        </FormattedMessage>
      </ResponsiveImagesWrapper>
    </DeviceVideoWrapper>
  );
}

DeviceVideo.defaultProps = {
  className: undefined,
  deviceType: 'light',
  hasDeviceOnMobile: false,
  mobileBorderRadius: '12',
  videoTitle: 'Video',
};

DeviceVideo.propTypes = {
  className: PropTypes.string,
  deviceType: PropTypes.oneOf(Object.keys(deviceTypes)),
  hasDeviceOnMobile: PropTypes.bool,
  mobileBorderRadius: PropTypes.string,
  videoId: PropTypes.string.isRequired,
  videoTitle: PropTypes.string,
};

export default React.memo(DeviceVideo);
